import {useNavigate} from 'react-router';
import {CreatePublicServiceConsentRequest} from '@di-shared/api/di/__generated';
import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {ROUTE_PATHS} from '@di-shared/routes';
import {DotLottieReact} from '@lottiefiles/dotlottie-react';

export interface HighwayUnpaidAboutProps {
  vin: string;
}

function HighwayUnpaidAbout({vin}: HighwayUnpaidAboutProps) {
  const {t} = useInferableTranslation();
  const navigate = useNavigate();

  function goToConsentPage() {
    navigate(
      ROUTE_PATHS.PUBLIC_SERVICE_CONSENTS_$CATEGORY.getFullPath({
        vin,
        category: CreatePublicServiceConsentRequest.category.HIGHWAY_UNPAID,
        nextUrl: ROUTE_PATHS.PUBLIC_SERVICE_HIGHWAY_UNPAID_SEARCH.getFullPath(vin),
      }),
      {replace: true}
    );
  }

  return (
    <div className="wrap">
      <Header left={<HeaderBackButton />}>
        <h1 className="headline_xxsmall nav_center_title">{t('T20364')}</h1>
      </Header>

      <main
        id="content"
        className="content"
      >
        <section className="section section_vehicle_intro unpaid_toll">
          <section className="section">
            <div className="intro_heading">
              <h2
                className="intro_heading_title"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('T20365')}
              </h2>
              <p
                className="intro_desc"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('T20366')}
              </p>
            </div>
            <div className="intro_motion">
              <div className="intro_imgbox">
                <DotLottieReact
                  className={'intro_img'}
                  src={'/assets/lottie/toll_inquiry_intro_01.lottie'}
                  autoplay
                  loop
                />
              </div>
            </div>
          </section>
          <section className="section">
            <div className="intro_heading">
              <h2
                className="intro_heading_title"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('T20367')}
              </h2>
              <p
                className="intro_desc"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('T20368')}
              </p>
            </div>
            <div className="intro_motion">
              <div className="intro_imgbox">
                <DotLottieReact
                  className={'intro_img'}
                  src={'/assets/lottie/toll_inquiry_intro_02.lottie'}
                  autoplay
                  loop
                />
              </div>
            </div>
          </section>
        </section>
        <section className="section section_notice">
          <div className="section_container">
            <strong className="notice_title">{t('T20369')}</strong>
            <ul className="notice_list">
              <li className="notice_item">{t('T20370')}</li>
              <li className="notice_item">{t('T20371')}</li>
            </ul>
          </div>
        </section>
      </main>

      <div className="floating_action_area">
        <button
          type="button"
          className="btn btn_large btn_filled btn_full"
          onClick={() => goToConsentPage()}
        >
          {t('T10218')}
        </button>
      </div>
    </div>
  );
}

export default HighwayUnpaidAbout;
